module.exports = __webpack_public_path__ + "img/bitstamp.6ac352a8.png";